export default __webpack_public_path__ + "static/favicon-92433d39100beb3c36e180c5a8765001.png";